import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useUtility, Stack, Text } from '@hub-la/design-system';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { VideoDuration } from '../../../domain/vos/video-duration.js';
import { GetPostType } from '../../../usecases/get-post-type.js';

const iconMap = {
  article: jsx(ArticleOutlinedIcon, {}),
  image: jsx(ImageOutlinedIcon, {}),
  pdf: jsx(PictureAsPdfOutlinedIcon, {}),
  video: jsx(PlayCircleOutlineIcon, {})
};
const Duration = ({
  post
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  const {
    palette
  } = useUtility();
  const {
    t
  } = useTranslation();
  const postType = new GetPostType().execute((_a = post === null || post === void 0 ? void 0 : post.cover) === null || _a === void 0 ? void 0 : _a.type);
  const icon = iconMap[postType];
  const duration = (_d = (_c = (_b = post === null || post === void 0 ? void 0 : post.cover) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.pages) !== null && _d !== void 0 ? _d : ((_f = (_e = post.cover) === null || _e === void 0 ? void 0 : _e.metadata) === null || _f === void 0 ? void 0 : _f.duration) && new VideoDuration((_j = (_h = (_g = post.cover) === null || _g === void 0 ? void 0 : _g.metadata) === null || _h === void 0 ? void 0 : _h.duration) !== null && _j !== void 0 ? _j : 0).format();
  return jsxs(Stack, Object.assign({
    flexDirection: "row",
    alignItems: "center",
    marginTop: 2
  }, {
    children: [icon && /*#__PURE__*/React.cloneElement(icon, {
      sx: {
        color: palette('onSurfaceVariant'),
        fontSize: 18
      }
    }), jsxs(Text, Object.assign({
      "data-testid": "video-duration",
      color: "onSurfaceVariant",
      variant: "caption",
      marginLeft: 1
    }, {
      children: [duration, " ", t(`postDetail.sidebar.durationSubtitle.${postType}`)]
    }))]
  }));
};

export { Duration };
